'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendHeapBatch = sendHeapBatch;

var _http = require('./util/http');

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var batchHeapUrl = '/api/logging/batch_heap';

function sendHeapBatch(payload) {
  return new Promise(function ($return, $error) {
    return Promise.resolve(_http2.default.post(batchHeapUrl, payload)).then($return, $error);
  });
}